// @flow
import {
  UPDATE_TARGET_STOCK,
  UPDATE_STOCK_STATUS
} from '../../actions/stock'
import type {
  UPDATE_TARGET_STOCK_TYPE,
  UPDATE_STOCK_STATUS_TYPE
} from '../../actions/stock'

type State = {
  targetStockHistory: Object[],
  stockHistory: Object,
  stockStatus: Object
}

const initialState: State = {
  targetStockHistory: [],
  stockHistory: {},
  stockStatus: {}
}

type Action = 
  | UPDATE_TARGET_STOCK_TYPE
  | UPDATE_STOCK_STATUS_TYPE

export default function stockReducer(state: State = initialState, action: Action): State {
  switch (action.type) {
    case UPDATE_TARGET_STOCK: {
      const { targetStockHistory, symbol } = action.payload
      const { stockHistory } = state
      stockHistory[symbol] = targetStockHistory
      return {
        ...state,
        stockHistory
      }
    }
    case UPDATE_STOCK_STATUS: {
      const { isFetching, error, symbol } = action.payload
      const { stockStatus } = state
      stockStatus[symbol] = { isFetching, error }
      return {
        ...state,
        stockStatus
      }
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/stock/index.js